<template>
  <footer
    class="
      profile-footer
      justify-content-center
      px-3
      d-flex
      align-items-center
      flex-wrap
    "
  >
    <span v-if="$i18n.locale === 'fa'" class="ml-3 py-2">
      ۱۴۰۳ - کلیه حقوق متعلق به شرکت نوآوران یکتا نت است.
    </span>
    <span v-else class="ml-3 py-2"> All Right Reserved. ImageRivar 2020 </span>
    <div class="pb-2 pt-0 p-sm-2">
      <a
        href="https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf"
        target="_blank"
        class="link"
        data-gtm-name="main_privacy"
      >
        {{ $t("privacy") }}
      </a>
      <span class="mx-2 font-weight-bold">.</span>
      <a
        href="https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf"
        target="_blank"
        class="link"
        data-gtm-name="main_terms_of_service"
      >
        {{ $t("termsOfService") }}
      </a>
      <!-- <span class="mx-2 font-weight-bold">.</span>
            <button @click="changeLang($i18n.locale)" class="btn link p-1">
                {{
                    {
                        fa: "English",
                        en: "فارسی",
                    }[$i18n.locale]
                }}
            </button> -->
    </div>
  </footer>
</template>

<script>
import { changeLang } from "~/utils";

export default {
  methods: {
    changeLang,
  },
};
</script>
